import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import BrandWordmark from "@/components/site/BrandWordmark";

export default function AdminLogin() {
  const [form, setForm] = useState({ username: "", password: "" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.post("/admin/login", form);
      localStorage.setItem("srih_admin_token", res.data.token);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center p-6">
      <div className="absolute inset-0 grid-lines opacity-40" />
      <div className="relative w-full max-w-md border border-white/10 bg-[#0F2952] p-10">
        <div className="mb-8">
          <BrandWordmark variant="compact" onDark={true} />
          <div className="mt-4 font-mono text-[10px] text-white/50 uppercase tracking-widest">Admin · Restricted access</div>
        </div>

        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-zinc-400 mb-2">Username</label>
            <input
              data-testid="admin-username"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              required
              className="w-full bg-transparent border border-white/15 focus:border-volt outline-none px-3 py-3 text-sm"
            />
          </div>
          <div>
            <label className="block font-mono text-[10px] uppercase tracking-widest text-zinc-400 mb-2">Password</label>
            <input
              type="password"
              data-testid="admin-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
              className="w-full bg-transparent border border-white/15 focus:border-volt outline-none px-3 py-3 text-sm"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="btn-volt w-full px-4 py-3 font-mono text-xs uppercase tracking-widest inline-flex items-center justify-center gap-2 disabled:opacity-50"
          >
            <Lock size={14} /> {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="mt-6 font-mono text-[10px] text-zinc-600 uppercase tracking-widest">
          Default: admin / srih2026
        </div>
      </div>
    </div>
  );
}
